"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlayerConfig = exports.ConfigTypes = exports.AuthTypes = void 0;
var _video = _interopRequireDefault(require("video.js"));
var _constants = require("../constants");
var _trackChangeHandler = require("../plugins/trackChangeHandler");
require("../plugins/InBandEventProcessor");
require("../plugins/FailoverPlugin");
require("../plugins/ComponentEventProcessor");
require("../plugins/BookmarksPlugin");
var _softChop = require("../middleware/softChop");
var _reload = require("../middleware/reload");
var _seekLimiter = require("../middleware/seekLimiter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Types are used to determine which player configuration to return.
 * This will allow the player to be configured differently (i.e, plugins, etc)
 * based on its determined configuration type.
 */
var ConfigTypes = exports.ConfigTypes = Object.freeze({
  SAFARI_DESKTOP: 'safari_desktop',
  IOS: 'ios',
  DEFAULT: 'default',
  BASE: 'base'
});

/**
 * Types are used to determine which auth scheme to use.
 * cookie/param
 */
var AuthTypes = exports.AuthTypes = Object.freeze({
  COOKIE: 'cookie',
  PARAM: 'param'
});

/**
 * Checks to see if the current browser is desktop Safari or
 * if the device is iOS.  If so, it will return those respective
 * types else it will return a type of DEFAULT.
 *
 * @returns {string}
 *          A configuration type.
 */
var getConfigType = function getConfigType() {
  if (_video["default"].browser.IS_IOS) {
    return ConfigTypes.IOS;
  }
  if (_video["default"].browser.IS_SAFARI) {
    return ConfigTypes.SAFARI_DESKTOP;
  }
  return ConfigTypes.DEFAULT;
};

/**
 * Value of the current config type as determined by `getConfigType`.
 */
var configType = getConfigType();

/**
 * Standard configuration for autoplay, controls and techOrder player options.
 */
var baseConfig = {
  autoplay: true,
  controls: true,
  techOrder: ['html5'],
  controlBar: {
    pictureInPictureToggle: false
  }
};

/**
 * HTML5 config that will use emulated tracks and default to
 * forcing HLS playback through videojs plugin regardless if
 * current browser supports native HLS or not.
 */
var emulatedHtml5 = {
  nativeAudioTracks: false,
  nativeVideoTracks: false,
  vhs: {
    overrideNative: true,
    parse708captions: false
  }
};

/**
 * HTML5 config that will use native tracks and default to
 * native HLS playback.
 */
var nativeHtml5 = {
  nativeAudioTracks: true,
  nativeVideoTracks: true,
  vhs: {
    overrideNative: false,
    parse708captions: false
  }
};

/**
 * Method that returns a configuration object to be passed to the
 * player and based on the current browser/device (ConfigType).
 *
 * @param {Array}     smartPathUrls
 *                    An array of smartPathUrls to be passed
 *                    to the Failover plugin.
 *
 * @param {Function}  failoverErrorHandler
 *                    Error handler passed to the Failover plugin
 *                    and called when the `FAILOVER_RETRY_LIMIT_REACHED` event
 *                    is triggered.
 *
 * @param {Function}  inBandDataHandler
 *                    Callback passed to the NativeInBandEventProcessorPlugin
 *                    or the EmulatedInBandEventProcessor plugin
 *                    when the `inBandEvent` is triggered.
 *
 * @param {string}    [type=configType]
 *                    The type of config to return.  The return value of getConfigType
 *                    is the default value.  This can be overridden to force
 *                    a specific type other than what getConfigType returns.
 *
 * @param {Object}    config
 *                    An object storing various config options necessary
 *
 * @param {string}    presentationType
 *                    The type of presentation. Possible values are 'live' or 'archive'
 *                    This will determine various aspects of the configuration, primarily plugins
 */

var getPlayerConfig = exports.getPlayerConfig = function getPlayerConfig(smartPathUrls, failoverErrorHandler, inBandDataHandler) {
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : configType;
  var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var presentationType = arguments.length > 5 ? arguments[5] : undefined;
  console.log("getPlayerConfig() : Using the ".concat(type, " configuration."));
  var plugins = {};
  var html5;
  var _config$customPlayerT = config.customPlayerTime,
    customPlayerTime = _config$customPlayerT === void 0 ? null : _config$customPlayerT,
    reloadConf = config.reloadConf;
  if (presentationType === _constants.PresentationTypes.ARCHIVE) {
    if (config.vttEndpoint) {
      plugins.ComponentEventProcessor = {
        vttEndpoint: config.vttEndpoint,
        dataHandler: inBandDataHandler,
        trackHandler: _trackChangeHandler.handleAddNativeTrack
      };
    }
    if (config.bookmarks) {
      plugins.bookmarksPlugin = {
        bookmarks: config.bookmarks,
        eventUrl: config.eventUrl
      };
    }
    if (reloadConf) {
      _video["default"].use('*', _reload.reloadMiddleware);
    }

    // lets use the customPlayerTime object to drive soft chop middleware
    if (customPlayerTime) {
      _video["default"].use('*', _softChop.softChopMiddleware);
    }
    _video["default"].use('*', _seekLimiter.seekLimiterMiddleware);
  }
  switch (type) {
    case ConfigTypes.SAFARI_DESKTOP:
      if (presentationType === _constants.PresentationTypes.LIVE) {
        plugins.inBandEventProcessor = {
          dataHandler: inBandDataHandler,
          trackHandler: _trackChangeHandler.handleAddNativeTrack
        };
        plugins.failoverPlugin = {
          urlList: smartPathUrls,
          errorHandler: failoverErrorHandler
        };
        html5 = _objectSpread(_objectSpread({}, emulatedHtml5), {}, {
          nativeTextTracks: false
        });
      } else {
        html5 = _objectSpread(_objectSpread({}, nativeHtml5), {}, {
          nativeTextTracks: false
        });
      }
      return _objectSpread(_objectSpread({}, baseConfig), {}, {
        html5: html5,
        plugins: plugins,
        auth: AuthTypes.COOKIE,
        customPlayerTime: customPlayerTime
      });
    case ConfigTypes.IOS:
      if (presentationType === _constants.PresentationTypes.LIVE) {
        plugins.inBandEventProcessor = {
          dataHandler: inBandDataHandler,
          trackHandler: _trackChangeHandler.handleAddNativeTrack
        };
        html5 = _objectSpread(_objectSpread({}, nativeHtml5), {}, {
          nativeTextTracks: true
        });
      } else {
        html5 = _objectSpread(_objectSpread({}, nativeHtml5), {}, {
          nativeTextTracks: false
        });
      }
      return _objectSpread(_objectSpread({}, baseConfig), {}, {
        html5: html5,
        plugins: plugins,
        auth: AuthTypes.COOKIE,
        customPlayerTime: customPlayerTime
      });
    case ConfigTypes.BASE:
      html5 = _objectSpread({}, emulatedHtml5);
      return _objectSpread(_objectSpread({}, baseConfig), {}, {
        html5: html5,
        plugins: {},
        auth: AuthTypes.PARAM,
        customPlayerTime: customPlayerTime
      });
    case ConfigTypes.DEFAULT:
    default:
      if (presentationType === _constants.PresentationTypes.LIVE) {
        plugins.inBandEventProcessor = {
          dataHandler: inBandDataHandler,
          trackHandler: _trackChangeHandler.handleAddEmulatedTrack
        };
        plugins.failoverPlugin = {
          urlList: smartPathUrls,
          errorHandler: failoverErrorHandler
        };
      }
      html5 = _objectSpread({}, emulatedHtml5);
      return _objectSpread(_objectSpread({}, baseConfig), {}, {
        html5: html5,
        plugins: plugins,
        auth: AuthTypes.PARAM,
        customPlayerTime: customPlayerTime
      });
  }
};